import { shopSellerApi } from '../api/shopSellerApi';

export const shopSellerRepo = {
    getAll: (params) => shopSellerApi.getAll(params),

    getMyShops: (params) => shopSellerApi.getMyShops(params),

    getById: (shopSellerId) => shopSellerApi.getById(shopSellerId),

    getAvailableSellers: (params) => shopSellerApi.getAvailableSellers(params),

    getByShop: (shopId, params) => shopSellerApi.getByShop(shopId, params),

    getTotalByShop: (shopId) => shopSellerApi.getTotalByShop(shopId),

    create: (data) => shopSellerApi.create(data),

    update: (shopSellerId, data) => shopSellerApi.update(shopSellerId, data),

    setStatus: (shopSellerId, status) => shopSellerApi.setStatus(shopSellerId, status),

    toggleStatus: (shopSellerId) => shopSellerApi.toggleStatus(shopSellerId),
};